import { CookiePopup as LoopCookie, Toast } from '@loophealth/loop-ui-web-library';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCookiesEnabled } from '../../../redux/slices/ApplicationStateSlice';
import { selectCookiesEnabled } from '../../../redux/slices/ApplicationStateSlice/selectors';

const CookiePopup: React.FC = () => {
    const toast = Toast.useToast();
    const dispatch = useDispatch();

    const cookiesState = useSelector(selectCookiesEnabled);
    const showCookiesBanner = cookiesState === null;

    const onAcceptCookies = () => {
        toast?.success('Thanks! Your preferences have been saved. Enjoy your experience on our site.');
        dispatch(setCookiesEnabled(true));
    };
    const onRejectCookies = () => {
        toast?.warning('Got it. We’ve saved your preferences. No cookies will be stored.');
        dispatch(setCookiesEnabled(false));
    };

    return showCookiesBanner ? (
        <LoopCookie isVisible={showCookiesBanner} onAccept={onAcceptCookies} onReject={onRejectCookies} />
    ) : null;
};

const CookiePopupWrapper: React.FC = () => {
    return (
        <Toast.ToastContainer showCloseIcon={true} maxWidth='800px'>
            <CookiePopup />
        </Toast.ToastContainer>
    );
};

export default CookiePopupWrapper;
